var config;
const urlPath = window.location.hostname

    if(urlPath === 'localhost'){
        config = {
            lab: 'https://onlineshop-nh.podrealm.com/backoffice',
            api_sso: 'https://api-uat.nhealth-asia.com/sso/api/',
            pathWeb: '/lab',
            api_upload_payment: 'https://onlineshop-nh.podrealm.com/backoffice/api/_upload_refPayment',
            api_confirm_transaction: 'https://onlineshop-nh.podrealm.com/backoffice/Transections/_comfirm_transections',
            lineapi: 'https://api.line.me/oauth2/v2.1',
            main: 'https://onlineshop-nh.podrealm.com',
            sharing_lineoa: 'https://line.me/R/ti/p/@nhealth',
            // podrealm: 'https://ocr-api-py.podrealm.com:4449',
            ocr_nh: 'https://api-uat.nhealth-asia.com/open_api_ocr',
            client_id_nh: '17971fbc89954532a92e14102ac5e26a',
            client_secret_nh: '115D910E13D8485e9805fA06b022b428',
            primo: 'https://nhealth-uat.primo-dev.com',
            primo_jwt_secret: 'fOzJzi4bJ48f8tunN/t9ZbBsWevoOh2gJUDekhfCJxj2IlhKueUrEwKcwHDpGbmG7jyyNCnlbZT5z2gbfi1Azw==',
            econsent_appid: 'LINE_OA'
        }
    } 
    else if(urlPath === 'nh-lab.podsable.com'){
        config = {
            lab: 'https://nhealth-lab.podrealm.com',
            api_sso: 'https://api-uat.nhealth-asia.com/sso/api/',
            pathWeb: '',
            api_upload_payment: '' ,
            api_confirm_transaction: '',
            lineapi: 'https://api.line.me/oauth2/v2.1',
            main: 'https://nhealth-lab.podrealm.com',
            sharing_lineoa: 'https://line.me/R/ti/p/@429qkotf',
            // podrealm: 'https://ocr-api-py.podrealm.com:4449',
            ocr_nh: 'https://api-uat.nhealth-asia.com/open_api_ocr',
            client_id_nh: '17971fbc89954532a92e14102ac5e26a',
            client_secret_nh: '115D910E13D8485e9805fA06b022b428',
            primo: 'https://nhealth-uat.primo-dev.com',
            primo_jwt_secret: 'fOzJzi4bJ48f8tunN/t9ZbBsWevoOh2gJUDekhfCJxj2IlhKueUrEwKcwHDpGbmG7jyyNCnlbZT5z2gbfi1Azw==',
            econsent_appid: 'LINE_OA'
        }
    }
    else if(urlPath === 'nhealth-lab.podrealm.com') {
        config = {
            lab: 'https://nhealth-lab.podrealm.com',
            api_sso: 'https://api-uat.nhealth-asia.com/sso/api/',
            pathWeb: '/lineoa',
            api_upload_payment: 'https://nhealth-lab.podrealm.com/api/_upload_refPayment',
            api_confirm_transaction: 'https://nhealth-lab.podrealm.com/Transections/_comfirm_transections',
            lineapi: 'https://api.line.me/oauth2/v2.1',
            main: 'https://nhealth-lab.podrealm.com',
            sharing_lineoa: 'https://line.me/R/ti/p/@429qkotf',
            // podrealm: 'https://ocr-api-py.podrealm.com:4449',
            ocr_nh: 'https://api-uat.nhealth-asia.com/open_api_ocr',
            client_id_nh: '17971fbc89954532a92e14102ac5e26a',
            client_secret_nh: '115D910E13D8485e9805fA06b022b428',
            primo: 'https://nhealth-uat.primo-dev.com',
            primo_jwt_secret: 'fOzJzi4bJ48f8tunN/t9ZbBsWevoOh2gJUDekhfCJxj2IlhKueUrEwKcwHDpGbmG7jyyNCnlbZT5z2gbfi1Azw==',
            econsent_appid: 'LINE_OA'
        }
    }
    else if(urlPath === 'weblabonline.nhealth-asia.com')
    {
        config = {
            lab: 'https://weblabonline.nhealth-asia.com',
            api_sso: 'https://api-uat.nhealth-asia.com/sso/api/',
            pathWeb: '/lab',
            api_upload_payment: 'https://weblabonline.nhealth-asia.com/api/_upload_refPayment',
            api_confirm_transaction: 'https://weblabonline.nhealth-asia.com/backoffice-lineoa/Transections/_comfirm_transections',
            lineapi: 'https://api.line.me/oauth2/v2.1',
            main: 'https://weblabonline.nhealth-asia.com',
            sharing_lineoa: 'https://line.me/R/ti/p/@nhealth',
            // podrealm: 'https://ocr-api-py.podrealm.com:4449',
            ocr_nh: 'https://api-uat.nhealth-asia.com/open_api_ocr',
            client_id_nh: '17971fbc89954532a92e14102ac5e26a',
            client_secret_nh: '115D910E13D8485e9805fA06b022b428',
            primo: 'https://nhealth-uat.primo-dev.com',
            primo_jwt_secret: 'fOzJzi4bJ48f8tunN/t9ZbBsWevoOh2gJUDekhfCJxj2IlhKueUrEwKcwHDpGbmG7jyyNCnlbZT5z2gbfi1Azw==',
            econsent_appid: 'LINE_OA'
        }
    }
    else if(urlPath === 'onlineshop.nhealth-asia.com')
    {
        config = {
            lab: 'https://onlineshop.nhealth-asia.com/backoffice',
            api_sso: 'https://api.nhealth-asia.com/openapi-sso/api/',
            pathWeb: '/lab',
            api_upload_payment: 'https://onlineshop.nhealth-asia.com/backoffice/api/_upload_refPayment',
            api_confirm_transaction: 'https://onlineshop.nhealth-asia.com/backoffice/Transections/_comfirm_transections',
            lineapi: 'https://api.line.me/oauth2/v2.1',
            main: 'https://onlineshop.nhealth-asia.com',
            sharing_lineoa: 'https://line.me/R/ti/p/@nhealth',
            ocr_nh: 'https://api.nhealth-asia.com/openapi-ocr',
            client_id_nh: 'fd97391db85a441d82e1941b5f00331d',
            client_secret_nh: 'c6E39512d76a4525AaE158C06C0a209b',
            primo: 'https://nhealth.primoworld.cloud',
            primo_jwt_secret: '+sIkrA6kQVW190WKy77fbPuTPFzXPBUj4Tl/bwgU/U16E0BAAAbG/bagrfFX5qQJVNgklhLj0/pNyEcgWm65Dw==',
            econsent_appid: 'LINE_OA'
        }
    }
    else if(urlPath === 'onlineshop-nh.podrealm.com' || urlPath === 'react-2a077.web.app')
    {
        config = {
            lab: 'https://onlineshop-nh.podrealm.com/backoffice',
            // api_sso: 'https://api-uat.nhealth-asia.com/sso/api/', //? uat
            api_sso: 'https://api.nhealth-asia.com/openapi-sso/api/', //? prod
            // pathWeb: '/lab_test',
            pathWeb: '/lab',
            api_upload_payment: 'https://onlineshop-nh.podrealm.com/backoffice/api/_upload_refPayment',
            api_confirm_transaction: 'https://onlineshop-nh.podrealm.com/backoffice/Transections/_comfirm_transections',
            lineapi: 'https://api.line.me/oauth2/v2.1',
            main: 'https://onlineshop-nh.podrealm.com',
            sharing_lineoa: 'https://line.me/R/ti/p/@nhealth',
            // podrealm: 'https://ocr-api-py.podrealm.com:4449',
            ocr_nh: 'https://api-uat.nhealth-asia.com/open_api_ocr', //? uat
            client_id_nh: '17971fbc89954532a92e14102ac5e26a',
            client_secret_nh: '115D910E13D8485e9805fA06b022b428',
            primo: 'https://nhealth-uat.primo-dev.com',
            primo_jwt_secret: 'fOzJzi4bJ48f8tunN/t9ZbBsWevoOh2gJUDekhfCJxj2IlhKueUrEwKcwHDpGbmG7jyyNCnlbZT5z2gbfi1Azw==',
            econsent_appid: 'LINE_OA'
        }
    }

export const Base_API = config;
